import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Button } from "components/common/Button";
import { ICONS, LABEL_KEYS } from "./constants";
import type { RevertButtonProps } from "./types";

export const RevertButton = ({
  direction,
  isBlocked,
  isReverting,
  onClick,
}: RevertButtonProps) => {
  const { t } = useTranslation();
  const Icon = ICONS[direction];

  return (
    <Button
      size="sm"
      variant="outline"
      disabled={isReverting || isBlocked}
      // A disabled button swallows hover, so the tooltip wrapper must receive it instead.
      className={clsx("shrink-0", isBlocked && "pointer-events-none")}
      startAdornment={<Icon size={14} />}
      onClick={onClick}
    >
      {t(LABEL_KEYS[direction])}
    </Button>
  );
};
